
import hasModel from '@/mixins/hasModel'

export default {
    mixins: [hasModel],

    computed: {
        computedSrc() {
            return this.model.src || require('@/assets/images/placeholder.png')
        },
    },
}
